import { type FC } from 'react';

import { type ViewModelProps } from '#packages/web/types/view-model-props';

import { SplashPageRenderer } from './splash-page.renderer';
import { type SplashPageViewModel } from './splash-page.view-model';

export type SplashPageContainerProps = ViewModelProps<SplashPageViewModel>;

export const SplashPageContainer: FC<SplashPageContainerProps> = ({
  viewModel: { version },
}) => {
  return <SplashPageRenderer version={version} />;
};
